import url from './url';



export default url(({ tagId = ':tagId', groupId = ':groupId' }) => `/tag-system/groups/${groupId}/tags/${tagId}`);
